import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import { ITooltip } from '../../../components/1elements'

const HMapDisplayNew = ({ onClick }) => {
  return (
    <ITooltip placement={'bottom'} content={'Add a New Heatmap'}>
      <AddIcon
        onClick={onClick || undefined}
        sx={(theme) => ({
          boxSizing: 'border-box',
          color: '#9A9A9A',
          cursor: 'pointer',
          height: '30px',
          width: '30px',
          '&:hover': { color: theme.palette.primary.accent }
        })}
      />
    </ITooltip>
  )
}

export default React.memo(HMapDisplayNew)
